/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol = _interopDefault(require('openlayers'));
var Vue = _interopDefault(require('vue'));
var core = require('../core');

var Circle = __ol.style.Circle;
var props = {
  radius: {
    type: Number,
    default: 5
  }
};

var methods = {
  /**
   * @return {ol.style.Circle}
   * @protected
   */
  createStyle: function createStyle() {
    return new Circle({
      radius: this.radius,
      snapToPixel: this.snapToPixel,
      fill: this._fill,
      stroke: this._stroke
    });
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return core.mergeDescriptors(core.imageStyle.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  },

  /**
   * @param {ol.style.Fill|Vue|undefined} fill
   * @return {void}
   */
  setFill: function setFill(fill) {
    fill = fill instanceof Vue ? fill.$style : fill;

    if (fill !== this._fill) {
      this._fill = fill;
      this.refresh();
    }
  },

  /**
   * @param {ol.style.Stroke|Vue|undefined} stroke
   * @return {void}
   */
  setStroke: function setStroke(stroke) {
    stroke = stroke instanceof Vue ? stroke.$style : stroke;

    if (stroke !== this._stroke) {
      this._stroke = stroke;
      this.refresh();
    }
  }
};

var watch = {
  radius: function radius() {
    this.refresh();
  }
};

var Style = {
  name: 'vl-style-circle',
  mixins: [core.imageStyle, core.withFillStrokeStyle],
  props: props,
  methods: methods,
  watch: watch
};

var index = {
  Style: Style,
  install: function install(Vue$$1) {
    Vue$$1.component(Style.name, Style);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/circle-style/index.js
// module id = 1177
// module chunks = 1